// extracted by mini-css-extract-plugin
export var md = "768px";
export var radioContainer = "RadioButton_radioContainer__D7Bsb";
export var shared = "'../../../shared.module.css'";
export var subQuestion = "RadioButton_subQuestion__22MqT";